module.exports = __webpack_public_path__ + "static/media/5f8de7ed5ae7590275f0751e_banner_800x600.8ed2b8c1.png";